import { useTheme } from "../../context/ThemeContext";

const TraderAddWithdrawCollateralModal: React.FC<{
  actionType: 'add' | 'withdraw';
  handleCloseModal: () => void;
  handleSubmit: () => void;
  amount: string;
  setAmount: (amount: string) => void;
}> = ({ actionType, handleCloseModal, handleSubmit, amount, setAmount }) => {
  const { theme } = useTheme();
  const inputClsName = `w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 ${theme === 'dark' ? 'dark' : ''} bg-black/10 dark:bg-white/10 text-[14px] text-black dark:text-white`

  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-gray-200 dark:bg-gray-800 rounded-lg p-4 sm:p-6 w-full max-w-md mx-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white">
          {actionType === 'add' ? 'Add Collateral' : 'Withdraw'}
        </h2>
        <button
          onClick={handleCloseModal}
          className="text-gray-500 hover:text-gray-700 dark:text-white dark:hover:text-gray-300 p-1"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div className="mb-4">
        <label htmlFor="amount" className="block text-sm font-medium text-gray-700 dark:text-white mb-2">
          Amount (τ)
        </label>
        <input
          type="number"
          id="amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className={inputClsName}
          placeholder="Enter amount"
          min="0"
          step="0.01"
        />
      </div>
      <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-4">
        <button
          onClick={handleCloseModal}
          className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-300 dark:bg-gray-600 hover:bg-gray-400 dark:hover:bg-gray-500 rounded-[100px] transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          disabled={!amount || Number(amount) <= 0}
          className={`px-4 py-2 text-white dark:text-black rounded-[100px] transition-colors bg-green-500 hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          {actionType === 'add' ? 'Add Collateral' : 'Withdraw'}
        </button>
      </div>
    </div>
  </div>;
};

export default TraderAddWithdrawCollateralModal;